var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var flexStyles = {
    root: function (componentStyleParameters) {
        var colorScheme = componentStyleParameters.theme.siteVariables.colorScheme, appTileVertical = componentStyleParameters.variables.appTileVertical;
        var colorSchemeDefault = colorScheme.default;
        return __assign({}, (appTileVertical && {
            color: colorSchemeDefault.foreground1,
            ":hover": {
                backgroundColor: colorSchemeDefault.backgroundHover,
                color: colorSchemeDefault.foregroundHover,
            },
        }));
    },
};
//# sourceMappingURL=flex-styles.js.map